module.exports = __webpack_public_path__ + "static/media/019-Kissen_ID_17.3fc767f7.mp3";